import type { HeapListResponseDataType } from 'shared/api';
import { ClusterHeapStatus, HeapMessageLevel } from 'shared/api';
import {
  HEAP_CALCULATION_LEGEND,
  VOLUME_CALCULATION_MESSAGE,
} from './constants';
import type { HeapCalculationMessage } from './types';

export const getHeapCalculationMessage = (
  heap: HeapListResponseDataType,
): HeapCalculationMessage => {
  if (heap.status === ClusterHeapStatus.Failed) {
    return {
      message: heap.message ?? VOLUME_CALCULATION_MESSAGE.Generic,
      messageLevel: heap.messageLevel ?? HeapMessageLevel.Error,
    };
  }

  if (heap.message) {
    return {
      message: heap.message,
      messageLevel: heap.messageLevel ?? HeapMessageLevel.Warning,
    };
  }

  return { message: null, messageLevel: null };
};

export const getHeapCalculationLegend = (message: string): string =>
  HEAP_CALCULATION_LEGEND[message] ?? message;
